export const FOOTER_ANCHOR_CLASSES = 'flex flex-column justify-between min-vh-100';

export const LOCK_BODY_SCROLL_CLASS = 'overflow-hidden! h-screen! lock-body';
